export default __webpack_public_path__ + "static/media/profile1.70c65733.jpg";